export const SITE_URL = 'https://growmoreitservices.com';

const attrSelector = (attr, key) =>
  attr === 'property' ? `meta[property="${key}"]` : `meta[name="${key}"]`;

const ensureMeta = (attr, key) => {
  let el = document.querySelector(attrSelector(attr, key));
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  return el;
};

const ensureLink = (rel) => {
  let el = document.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', rel);
    document.head.appendChild(el);
  }
  return el;
};

const read = (el) => el?.getAttribute('content') ?? el?.getAttribute('href') ?? null;

const absoluteUrl = (value) => {
  if (!value) return `${SITE_URL}/logo.png`;
  if (value.startsWith('http')) return value;
  return `${SITE_URL}${value.startsWith('/') ? value : `/${value}`}`;
};

export const pageUrl = (path = '/') => {
  if (path.startsWith('http')) return path;
  return `${SITE_URL}${path.startsWith('/') ? path : `/${path}`}`;
};

export const applyPageSeo = ({
  title,
  description,
  keywords,
  path = '/',
  image = '/logo.png',
  type = 'website',
  robots = 'index,follow,max-image-preview:large,max-snippet:-1,max-video-preview:-1'
}) => {
  const canonical = pageUrl(path);
  const ogImage = absoluteUrl(image);

  const descEl = ensureMeta('name', 'description');
  const keyEl = ensureMeta('name', 'keywords');
  const robotsEl = ensureMeta('name', 'robots');
  const authorEl = ensureMeta('name', 'author');
  const geoEl = ensureMeta('name', 'geo.region');
  const placeEl = ensureMeta('name', 'geo.placename');
  const canonEl = ensureLink('canonical');
  const ogType = ensureMeta('property', 'og:type');
  const ogTitle = ensureMeta('property', 'og:title');
  const ogDesc = ensureMeta('property', 'og:description');
  const ogUrl = ensureMeta('property', 'og:url');
  const ogImageEl = ensureMeta('property', 'og:image');
  const ogSite = ensureMeta('property', 'og:site_name');
  const ogLocale = ensureMeta('property', 'og:locale');
  const twCard = ensureMeta('name', 'twitter:card');
  const twTitle = ensureMeta('name', 'twitter:title');
  const twDesc = ensureMeta('name', 'twitter:description');
  const twImage = ensureMeta('name', 'twitter:image');

  const prev = {
    title: document.title,
    description: read(descEl),
    keywords: read(keyEl),
    robots: read(robotsEl),
    author: read(authorEl),
    geo: read(geoEl),
    place: read(placeEl),
    canonical: read(canonEl),
    ogType: read(ogType),
    ogTitle: read(ogTitle),
    ogDesc: read(ogDesc),
    ogUrl: read(ogUrl),
    ogImage: read(ogImageEl),
    ogSite: read(ogSite),
    ogLocale: read(ogLocale),
    twCard: read(twCard),
    twTitle: read(twTitle),
    twDesc: read(twDesc),
    twImage: read(twImage)
  };

  document.title = title;
  descEl.setAttribute('content', description || '');
  keyEl.setAttribute('content', keywords || '');
  robotsEl.setAttribute('content', robots);
  authorEl.setAttribute('content', 'Growmore IT Services');
  geoEl.setAttribute('content', 'IN-MH');
  placeEl.setAttribute('content', 'Satara');
  canonEl.setAttribute('href', canonical);
  ogType.setAttribute('content', type);
  ogTitle.setAttribute('content', title);
  ogDesc.setAttribute('content', description || '');
  ogUrl.setAttribute('content', canonical);
  ogImageEl.setAttribute('content', ogImage);
  ogSite.setAttribute('content', 'Growmore IT Services');
  ogLocale.setAttribute('content', 'en_IN');
  twCard.setAttribute('content', 'summary_large_image');
  twTitle.setAttribute('content', title);
  twDesc.setAttribute('content', description || '');
  twImage.setAttribute('content', ogImage);

  return () => {
    document.title = prev.title;
    const restore = (el, value, attr = 'content') => {
      if (value != null) el.setAttribute(attr, value);
    };
    restore(descEl, prev.description);
    restore(keyEl, prev.keywords);
    restore(robotsEl, prev.robots);
    restore(authorEl, prev.author);
    restore(geoEl, prev.geo);
    restore(placeEl, prev.place);
    restore(canonEl, prev.canonical, 'href');
    restore(ogType, prev.ogType);
    restore(ogTitle, prev.ogTitle);
    restore(ogDesc, prev.ogDesc);
    restore(ogUrl, prev.ogUrl);
    restore(ogImageEl, prev.ogImage);
    restore(ogSite, prev.ogSite);
    restore(ogLocale, prev.ogLocale);
    restore(twCard, prev.twCard);
    restore(twTitle, prev.twTitle);
    restore(twDesc, prev.twDesc);
    restore(twImage, prev.twImage);
  };
};
